<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ms_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ms_emname">
            <label class="weui-form-preview__label">{{customLabel.ms_emname || "补卡人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.ms_emname}}
              <call-mobile :em-id="form.main.ms_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ms_department">
            <label class="weui-form-preview__label">{{customLabel.ms_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.ms_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ms_mobile">
            <label class="weui-form-preview__label">{{customLabel.ms_mobile || "手机号"}}</label>
            <span class="weui-form-preview__value">{{form.main.ms_mobile}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ms_signtime">
            <label class="weui-form-preview__label">{{customLabel.ms_signtime || "补卡时间"}}</label>
            <span class="weui-form-preview__value">{{form.main.ms_signtime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ms_address"> 
            <label class="weui-form-preview__label">{{customLabel.ms_address || "补卡地址"}}</label>
            <span class="weui-form-preview__value">{{form.main.ms_address}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ms_remark">
            <label class="weui-form-preview__label">{{customLabel.ms_remark || "补卡理由"}}</label>
            <span class="weui-form-preview__value">{{form.main.ms_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.ms_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/signcard_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/mobilesigncard",
      codeField: "ms_code",
      statusField: "ms_statuscode",
      caller: "MobileSignCard",
      xtype: "oa-mobilesigncard-formpanel",
    };
  }
};
</script>